import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import PageTitle from "../../../../../components/PageTitle";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../../../utils/ApiMethod";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";

// import html2pdf from 'html2pdf.js';

const DownloadStudentAttendanceCard = () => {
  const { id } = useParams();
  // console.log(id, "id through param");
  //  console.log(selectedRow, " from download selectedRow");

  //  console.log('jhjhjh --------- ', jhjhjh[0]);
  const [selectedRow, setSelectedRow] = useState<any>();
  // console.log(selectedRow, " from download selectedRow");
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id) {
          const response = await api.fetchData(
            `/api/attendance/by/attendanceId/${id}`
          );
          if (response.status !== 200) {
            const errorMsg = await response.json();
            console.log(errorMsg, "error messahe");
            // setIsResponse(errorMsg?.message || "Unknown error occurred.");
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          // const data = await response.json(); // Assuming response.data is JSON data
          setSelectedRow(response.data[0]);
          // console.log(response.data[0], "response.data");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        // setIsResponse("Error fetching examination. Please try again later.");
      }
    };
    fetchData();
  }, [id]);

  const navigate = useNavigate();

  // const handleDownloadAttendanceCard = () => {
  //   window.print();
  // };

  //--------------------------------------------------
  // const handleDownloadAttendanceCard = () => {
  //   console.log("initiated to download attendance");
  //   const pdf = new jsPDF();
  //   const modalContent = document.getElementById("modal-content");
  //   if (modalContent) {
  //     html2canvas(modalContent).then((canvas) => {
  //       // Add the canvas content to the PDF
  //       pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0, 0, 200, 200); // A4 size: 210 x 297 mm
  //       // Save the PDF document
  //       pdf.save(`attendance_card of ${user.enrollment_no}.pdf`);
  //     });
  //   }
  // };
  //----------------------------------------------------------
  const handleDownloadAttendanceCard = () => {
    window.print();
    // console.log("Download attendance initiated");
    // const elementContent = document.getElementById("modal-content"); // Id of the element you want to print
    // console.log("Download attendance initiated1234");
    // // html2pdf().from(elementContent).save(`Attendance Card For ${selectedRow?.studentName} of Subject ${selectedRow.subjectName}}` );
    // console.log("Download attendance initiated-------------------");
  };

  //--------------------------------
  const { user,
    //  userLoggedIn, loading, error, userId 
    } = useSelector(
    (state: RootState) => ({
      user: state.Auth.user,
      loading: state.Auth.loading,
      error: state.Auth.error,
      userLoggedIn: state.Auth.userLoggedIn,
      userId: state.Auth._id,
    })
  );
  // console.log("selectedRow.subjectName",selectedRow?.subjectName)
  const [subjectN , setSubjectN] = useState<any>();
  // console.log("subjectN",subjectN);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id) {
          const response = await api.fetchData(
            `/api/fetch/subject/name/${selectedRow?.subjectName}`
          );
          if (response.status !== 200) {
            const errorMsg = await response.json();
            console.log(errorMsg, "error messahe");
            // setIsResponse(errorMsg?.message || "Unknown error occurred.");
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          // const data = await response.json(); // Assuming response.data is JSON data
          setSubjectN(response.data[0].subjectName);
          // console.log(response.data[0], "response.data");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        // setIsResponse("Error fetching examination. Please try again later.");
      }
    };
    fetchData();
  }, [selectedRow?.subjectName]);
//console.log(user,"email of user");
  // console.log(user, "user details from Download Attendance card.");
  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: "Academic Record", path: "admin/attendance/Attendance" },
          {
            label: "Attendance Card",
            path: "admin/attendance/Attendance",
            active: true,
          },
        ]}
        title={"Attendance Card download"}
      />

      <div>
        <div className="table-responsive">
          <div
            id="modal-content"
            className="d-flex justify-content-center align-item-center"
          >
            <div className="text-center table-responsive ">
              <u>
                <h2>Attendance Card</h2>
              </u>
              <table>
                <div className="text-center ">
                  <h2 style={{ backgroundColor: "#07294d", color: "white" }}>
                    Student’s Details
                  </h2>
                </div>
                <table
                  className="table table-striped table-bordered"
                  style={{ backgroundColor: "#DEEAF6" }}
                >
                  <tbody>
                    <tr>
                      <th>Name</th>
                      <td>{selectedRow?.studentName}</td>
                      <th>Course</th>
                      <td>
                        {selectedRow?.courseName === "01"
                          ? "MBBS"
                          : "B.Sc.(Honors) Nurshing"}
                      </td>
                    </tr>
                    <tr>
                      <th>Batch</th>
                      <td>{selectedRow?.session}</td>
                      <th>Roll No.</th>
                      <td>{user?.roll_number}</td>
                    </tr>
                    <tr>
                      <th>Enrollment No.</th>
                      <td>{selectedRow?.enrollment_no}</td>
                      <th>Contact No.</th>
                      <td>{user?.student_mobile}</td>
                    </tr>
                    <tr>
                      <th>Email ID</th>
                      <td colSpan={3}>{user?.corr_email}</td>
                    </tr>
                  </tbody>
                </table>
                <div className="text-center ">
                  <h2 style={{ backgroundColor: "#07294d", color: "white" }}>
                    Attendance Details
                  </h2>
                </div>
                <table
                  className="table table-striped table-bordered table-hover"
                  style={{ backgroundColor: "#DEEAF6" }}
                >
                  <tbody>
                    <tr>
                      <th>Professional</th>
                      <td colSpan={6}>
                      {selectedRow?.courseName === "01"
                          ? 
                          (selectedRow?.examName === "M1"
                            ? "First Professional MBBS"
                            : selectedRow?.examName === "M2"
                            ? "Second Professional MBBS"
                            : selectedRow?.examName === "M3I"
                            ? "Third Professional Part I"
                            : "Third Professional Part II")
                            :
                            (selectedRow?.examName === "N1"
                              ? "First Professional B.Sc. (Hons.) Nurshing"
                              : selectedRow?.examName === "N2"
                              ? "Second Professional B.Sc. (Hons.) Nurshing"
                              : selectedRow?.examName === "N3"
                              ? "Third Professional B.Sc. (Hons.) Nurshing"
                              : "Fourth Professional B.Sc. (Hons.) Nurshing")
                           }
                      </td>
                    </tr>
                    <tr>
                      <th rowSpan={2}>Subject</th>
                      <th colSpan={3}>Theory/Tutorial </th>
                      <th colSpan={3}>Practical/Clinical Posting</th>
                    </tr>
                    <tr>
                      <th>Held</th>
                      <th>Attended</th>
                      <th>%</th>
                      <th>Held</th>
                      <th>Attended</th>
                      <th>%</th>
                    </tr>
                    {selectedRow && (
                      <tr key={selectedRow?.subjectName}>
                        <td>{subjectN}</td>
                        {/* <td>{selectedRow?.subjectName}</td> */}
                        <td>{selectedRow?.totalTheoryClass}</td>
                        <td>{selectedRow?.attendedTheoryClass}</td>
                        <td>{selectedRow?.theoryClassPercentage.toFixed(2)}</td>
                        <td>{selectedRow?.totalPracticalClass}</td>
                        <td>{selectedRow?.attendedPracticalClass}</td>
                        <td>
                          {selectedRow?.practicalClassPercentage.toFixed(2)}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div>
                  <ul style={{ textAlign: "justify" }}>
                    <li className="text-justify">
                      This card is generated as per the attendance records
                      submitted by the department concerned from time to time.
                    </li>
                    <li className="text-justify">
                      In case of any discrepancy in the attendance, the same
                      should be brought to the knowledge of the department
                      concerned within 3 days of the release of the attendance.
                    </li>
                    <li className="text-justify">
                      This document is system-generated; hence, no signature is
                      required.
                    </li>
                  </ul>
                </div>
              </table>
              {/* </Modal.Body> */}
            </div>
          </div>

          {/* <Modal.Footer> */}
          <Button
            variant="light"
            onClick={() =>
              navigate("/pages/dashboard/download-attendance-card")
            }
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleDownloadAttendanceCard}
            style={{ backgroundColor: "#b15110" }}
          >
            Download Attendance Card
          </Button>
          {/* </Modal.Footer> */}
        </div>
        {/* </Modal> */}
      </div>
    </>
  );
};

export default DownloadStudentAttendanceCard;
